<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BPwvpV/tc-custom/9781250169327.jpg?1730603647714" alt="This image is the cover for the book Medusa Uploaded, The Medusa Cycle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Medusa Uploaded, The Medusa Cycle
      </h1>
      <p class="bookDescription body article font2">
        <b>This sci-fit thriller about a rogue starship servant has “mysteries around every corner. . . . the end product is just as fantastic as one would hope” (<i>Los Angeles Times</i>).</b><br/><br/><i>My name is Oichi Angelis, and I am a worm.</i><br/><br/><i>They see me every day. They consider me harmless. And that’s the trick, isn’t it?</i><br/><br/>A generation starship can hide many secrets. When an Executive clan suspects Oichi of insurgency and discreetly shoves her out an airlock, one of those secrets finds and rescues her.<br/><br/>Officially dead, Oichi begins to rebalance power one assassination at a time and uncovers the shocking truth behind the generation starship and the Executive clans.<br/><br/>“Readers will be riveted.” —<i>Publishers Weekly</i>, starred review<br/><br/>“The first book in the Medusa Cycle does not disappoint.” —<i>RT Book Reviews</i><br/><br/>“A chilling tale of class warfare in deep space.” —<i>Booklist</i><br/><br/>“An enticing start to a new space opera .” —<i>Library Journal</i><br/><br/>“One of the best generation starship novels.” —<i>SF Revu</i><br/><br/>“The worlds . . . both physical and virtual, are richly detailed and gorgeously imagined.” —<i>Kirkus Reviews</i><br/><br/>“Disturbing, exciting, and frankly kind of mind-blowing.” —Annalee Newitz, author of <i>Autonomous</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Devenport
      </h2>
      
      <p class="authorDescription body article">EMILY DEVENPORT has written several novels under various pseudonyms including one which was a finalist for the Philip K. Dick award. She is currently studies Geology and works as a volunteer at the Desert Botanical Garden in Phoenix. Emily is the author of <I>Medusa Uploaded</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cd7d8ee